import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Pseudo-elements/after";
import * as React from 'react';
export default {
  Content,
  React
};